import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Login } from './components/Login';
import { Home } from './components/Home';
import { PropertyListingForm } from './components/PropertyListingForm';
import { PropertyViewingSheetForm } from './components/PropertyViewingSheetForm';
import { PropertyInspectionForm } from './components/PropertyInspectionForm';
import { Clients } from './components/Clients';
import { HotProperties } from './components/HotProperties';
import { NotFound } from './components/NotFound';
import { PropertyDetails } from './components/PropertyDetails';
import { PropertySearch } from './components/PropertySearch';
import { PropertyRecentListings } from './components/PropertyRecentListings';
import { Georegion } from './components/Georegion';
import { Favourites } from './components/Favourites';
import { RegisterClient } from './components/RegisterClient';
import { PropertySearchResultsLists } from './components/PropertySearchResultsLists';
import './custom.css';
import GroupMap from './components/GroupMap';
import NearbyMap from './components/NearbyMap';
import SingleMap from './components/SingleMap';
import { BuyerProperties } from './components/BuyerProperties';
import { AddBuyerProperties } from './components/AddBuyerProperties';
import { MyDraftListings } from './components/MyDraftListings';
import { ScrollProvider } from './components/ScrollContext';

export default function App() {
  function isAuth() {
    return localStorage.getItem('userId') !== null;
  }

  function PrivateRoute({ children }) {
    const auth = isAuth();
    return auth ? children : <Navigate to="/" />;
  }

  function PublicRoute({ children }) {
    const auth = isAuth();
    return auth ? <Navigate to="/home" /> : children;
  }

  return (
    <ScrollProvider>
      <Layout>
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/listingform"
            element={<PropertyListingForm />}
          />
          <Route
            exact
            path="/PropertySearch"
            element={<PropertySearch />}
          />
          <Route
            exact
            path="/PropertyRecentListings"
            element={<PropertyRecentListings />}
          />
          <Route
            exact
            path="/ViewingSheetForm"
            element={<PropertyViewingSheetForm />}
          />
          <Route
            exact
            path="/Inspectionform"
            element={<PropertyInspectionForm />}
          />
          <Route exact path="/MapPerCard" element={<SingleMap />} />
          <Route exact path="/MyClients" element={<Clients />} />
          <Route
            exact
            path="/HotProperties"
            element={<HotProperties />}
          />
          <Route
            exact
            path="/PropertyDetails"
            element={<PropertyDetails />}
          />
          <Route exact path="/Favourites" element={<Favourites />} />

          <Route exact path="/Georegion" element={<Georegion />} />
          <Route
            exact
            path="/RegisterAClient"
            element={<RegisterClient />}
          />
          <Route
            exact
            path="/PropertySearchResultsLists"
            element={<PropertySearchResultsLists />}
          />
          <Route
            exact
            path="/BuyerProperties"
            element={<BuyerProperties />}
          />
          <Route exact path="/Map" element={<GroupMap />} />
          <Route exact path="/NearbyMap" element={<NearbyMap />} />
          <Route exact path="/AddBuyerProperties" element={<AddBuyerProperties />} />
          <Route exact path="/MyDraftListings" element={<MyDraftListings />} />
          <Route exact path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </ScrollProvider>
  );
}
